/*level,minzoom,maxzoom配置必须是数字*/
let xiazuanConfig = {
    defaultBorderColor:"#dea6de",/*默认的高亮边框颜色*/
    defaultBorderWidth:4,/*默认的高亮边框宽度*/
    defaultBorderOpacity:1,/*默认的高亮边框透明度*/
    defaultOverFillColor:"#0127EB",/*默认下钻鼠标悬浮高亮颜色*/
    defaultOverFillOpacity:0.2,/*默认下钻鼠标悬浮高亮透明度*/

    qgConfig:{/*全国级别配置,此配置单独在此处*/
      "levelName":"全国",
      "level":0,
      "layerId":"国界",
      "sourceId":"dt_gj",
      "sourceLayer":"dt_gj",
      "ptLayerId":"中国",
      "sourceId_pt":"dt_gj_pt",
      "sourceLayer_pt":"dt_gj_pt",
      "borderColor":"",
      "borderWidth":"",
      "borderOpacity":"",
      "overFillColor":"",
      "overFillOpacity":"",
      "minzoom":0,
      "maxzoom":4,
      "layer_ht":"dt_sy_ht",
      "layer_fill":"dt_gj_fill",
      "layer_bk":"dt_gj_bk"
    },
    xzqLayer:[
      {
        "levelName":"省",
        "level":1,
        "layerId":"省域",
        "sourceId":"dt_sy",
        "sourceLayer":"dt_sy",
        "ptLayerId":"省点",
        "sourceId_pt":"dt_sy_pt",
        "sourceLayer_pt":"dt_sy_pt",
        "borderColor":"",
        "borderWidth":"",
        "borderOpacity":"",
        "overFillColor":"",
        "overFillOpacity":"",
        "minzoom":3,
        "maxzoom":6,/*把省写低一个级别，正常是7，为了省域的下钻图层和地市域的下钻图层不重叠*/
        "layer_ht":"dt_sy_ht",
        "layer_fill":"dt_sy_fill",
        "layer_bk":"dt_sy_bk",
        "additionalLayers":[],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
      },
      {
        "levelName":"地市",
        "level":2,
        "layerId":"地市域",
        "sourceId":"dt_dsy",
        "sourceLayer":"dt_dsy",
        "ptLayerId":"地市点",
        "sourceId_pt":"dt_dsy_pt",
        "sourceLayer_pt":"dt_dsy_pt",
        "borderColor":"",
        "borderWidth":"",
        "borderOpacity":"",
        "overFillColor":"",
        "overFillOpacity":"",
        "minzoom":6,
        "maxzoom":8,
        "layer_ht":"dt_dsy_ht",
        "layer_fill":"dt_dsy_fill",
        "layer_bk":"dt_dsy_bk",
        "additionalLayers":[],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
      },
      {
        "levelName":"县",
        "level":3,
        "layerId":"县域",
        "sourceId":"dt_xy",
        "sourceLayer":"dt_xy",
        "ptLayerId":"县点",
        "sourceId_pt":"dt_xy_pt",
        "sourceLayer_pt":"dt_xy_pt",
        "borderColor":"",
        "borderWidth":"",
        "borderOpacity":"",
        "overFillColor":"",
        "overFillOpacity":"",
        "minzoom":8,
        "maxzoom":10,
        "layer_ht":"dt_xy_ht",
        "layer_fill":"dt_xy_fill",
        "layer_bk":"dt_xy_bk",
        "additionalLayers":[],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
      },
      {
        "levelName":"乡镇",
        "level":4,
        "layerId":"乡镇域",
        "sourceId":"dt_xzy",
        "sourceLayer":"dt_xzy",
        "ptLayerId":"乡镇点",
        "sourceId_pt":"dt_xzy_pt",
        "sourceLayer_pt":"dt_xzy_pt",
        "borderColor":"",
        "borderWidth":"",
        "borderOpacity":"",
        "overFillColor":"",
        "overFillOpacity":"",
        "minzoom":10,
        "maxzoom":12,
        "layer_ht":"dt_xzy_ht",
        "layer_fill":"dt_xzy_fill",
        "layer_bk":"dt_xzy_bk",
        "additionalLayers":[],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
      },
      {
        "levelName":"村",
        "level":5,
        "layerId":"村域",
        "sourceId":"dt_cy",
        "sourceLayer":"dt_cy",
        "ptLayerId":"村点",
        "sourceId_pt":"dt_cy_pt",
        "sourceLayer_pt":"dt_cy_pt",
        "borderColor":"",
        "borderWidth":"",
        "borderOpacity":"",
        "overFillColor":"",
        "overFillOpacity":"",
        "minzoom":12,
        "maxzoom":18,
        "layer_ht":"dt_cy_ht",
        "layer_fill":"dt_cy_fill",
        "layer_bk":"dt_cy_bk",
        "additionalLayers":[],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
      }
    ]
};
export default xiazuanConfig;



// WEBPACK FOOTER //
// ./src/common/drillDown/drillDownConfig.js